import React from 'react';
import { createPortal } from 'react-dom';
import { TextButton } from '../../TextButton/TextButton';
import styles from './SkipIntroButton.module.scss';

export const SKIP_INTRO_BUTTON_CONTAINER_ID = 'mggpSkipIntroButtonContainer';

interface IPropTypes {
  text: string;
  onClick: () => void;
}

export const SkipIntroButton: React.FC<IPropTypes> = React.memo(
  ({ text, onClick }) => {
    const container = document.querySelector(
      `#${SKIP_INTRO_BUTTON_CONTAINER_ID}`
    );

    return container
      ? createPortal(
          <div className={styles.SkipIntroButtonWrapper}>
            <TextButton text={text} onClick={onClick} />
          </div>,
          container
        )
      : null;
  }
);
SkipIntroButton.displayName = 'SkipIntroButton';
